import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button } from 'primereact/button'
import LtsCalendar from '../../../components/lottus/lts-calendar'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import LtsDropdownSimNao from '../../../components/lottus/lts-dropdown-sim-nao'
import { LoadingSpinner } from '../../../components/loadingSpinner/LoadingSpinner'
import { Page } from '../../../components/page/Page'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import { routes } from '../../../constants'
import * as listPageUtils from '../../../utils/listPageContainerUtils'
import utils from '../../../utils'
import storage from '../../../services/stoage.service'
import { pathRegistros } from '../../../services/api-crud-dinamico'
import { actions } from '../crudDinamico.actions'
import { formatCell } from '../column-registry'
import { CrudDinamicoList } from './CrudDinamicoList'

const mapStateToProps = (state) => {
  // selection=[] com tabela vazia marca o checkbox do cabeçalho no PrimeReact 9
  // ([].every() é true e array vazio é truthy) — null curto-circuita o allRowsSelected
  const selecionados = state.crudCrudDinamicoState.selectedRecords
  return {
    chave: state.crudCrudDinamicoState.chave,
    definicao: state.crudCrudDinamicoState.definicao,
    messages: state.crudCrudDinamicoState.messages,
    showHideColumns: state.crudCrudDinamicoState.showHideColumns,
    columns: state.crudCrudDinamicoState.columns,
    records: state.crudCrudDinamicoState.records,
    isLoadingRecords: state.crudCrudDinamicoState.isLoadingRecords,
    first: state.crudCrudDinamicoState.index,
    rows: state.crudCrudDinamicoState.max,
    totalRecords: state.crudCrudDinamicoState.count,
    sortField: state.crudCrudDinamicoState.sortField,
    order: state.crudCrudDinamicoState.sortOrder,
    selectedFilters: state.crudCrudDinamicoState.selectedFilters,
    selectedRecords: selecionados && selecionados.length > 0 ? selecionados : null,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    carregarTela: (chave) => dispatch(actions.carregarTela(chave)),
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    changeFilter: (column, e, chave, tipoFiltro) => {
      const target = e.target
      dispatch(actions.setSelectedFilters(target.name, target.value, null, null, tipoFiltro))
      setTimeout(() => {
        dispatch(actions.executeFilter(`${pathRegistros(chave)}/all`))
      }, 400)
    },
    setSelectedRecords: (e) => {
      dispatch(actions.setSelectedRecords(e))
    },
    setColumns: (columns) => dispatch(actions.loadColumns(columns)),
    removeAll: () => dispatch(actions.excluirSelecionados(ownProps.match.params.chave)),
    loadFavorito: (menu) => {
      dispatch(actions.loadFavorito(menu))
    },
    removeFavorito: (menu) => {
      dispatch(actions.removeFavorito(menu))
    },
    adicionarFavorito: (menu) => {
      dispatch(actions.adicionarFavorito(menu))
    },
    clearSelectedFilters: () => {
      dispatch(actions.clearSelectedFilters())
    },
  }
}

class CrudDinamicoListPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.dataTableRef = React.createRef()
    this.columnSelect = React.createRef()
    this.hideBtnImportacao = true
    this.showHideColumns = []
    this.showDialogVisao = false
    this.showCSVButton = false
    this.state = {
      dadosFavorito: null,
      favorito: 0,
      showDialogRemove: false,
    }
    actions.afterRemove = () => {
      this.props.carregarTela(this.getChave())
    }
  }

  getChave = () => {
    return this.props.match.params.chave
  }

  // sem coluna de seleção não há exclusão em massa: esconde o botão de excluir do toolbar
  get hideBotaoRemover() {
    return !!(this.props.definicao && this.props.definicao.selecaoMultipla === false)
  }

  // lido pelo getConfirmDialog do DefaultToolBar (confirm chama props.removeAll + hideDialog)
  get showDialogRemove() {
    return this.state.showDialogRemove
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  // botão de exclusão em massa: o getRemoveButton do DefaultToolBar está vazio no projeto,
  // então o botão entra pelo gancho getCustomButtons
  getCustomButtons = () => {
    if (this.hideBotaoRemover) {
      return null
    }
    const permissoes = utils.getPermissoesPorMenu(
      storage.getMenus(),
      storage.getOidCurrentMenu(),
      null,
      storage.getPortalCliente()
    )
    if (permissoes && !permissoes.excluir) {
      return null
    }
    const temSelecao = (this.props.selectedRecords || []).length > 0
    return (
      <div className="p-toolbar-group-left">
        <Button
          disabled={!temSelecao}
          onClick={() => this.setState({ showDialogRemove: true })}
          label={utils.getMessage(this.props.messages, 'label.remover') || 'Remover'}
          icon="pi pi-trash"
          style={{ marginRight: '.25em' }}
          className="p-button-danger"
        />
      </div>
    )
  }

  componentDidMount() {
    this.props.carregarTela(this.getChave())
    this.loadFavorito()
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.chave !== prevProps.match.params.chave) {
      this.props.carregarTela(this.getChave())
    } else if (this.showHideColumns.length === 0) {
      this.showHideColumns = prevProps.showHideColumns
    }
  }

  loadFavorito() {
    listPageUtils.loadFavorito(this, actions)
  }

  changeFavorito() {
    listPageUtils.changeFavorito(this, actions)
  }

  newHandler = () => {
    this.props.history.push(`${routes.PATH_CRUD_DINAMICO}/${this.getChave()}/novo`)
  }

  // presença deste método habilita o botão de exclusão do DefaultToolBar,
  // que dispara this.props.removeAll()
  removeHandler = () => {
    this.props.removeAll()
  }

  onPage = (e) => {
    listPageUtils.onPage(this, e)
  }

  onSort = (e) => {
    listPageUtils.onSort(this, e)
  }

  // contrato do overlay "Colunas" do DefaultToolBar (ListBox.onChange)
  onColumnToggle = (event) => {
    listPageUtils.onColumnToggle(event, this)
  }

  onSelectionChange = (e) => {
    // linhas somente leitura (registros gerais da Lottus) não entram na seleção para exclusão
    const selecionaveis = (e.value || []).filter((registro) => !registro.somenteLeitura)
    this.props.setSelectedRecords(selecionaveis)
  }

  buildHeader = () => {
    const titulo = (this.props.definicao && this.props.definicao.tituloListagem) || this.getChave()
    return <DefaultToolBar listPageContainer={this} title={titulo} />
  }

  oidTemplate = (rowData) => {
    if (rowData.somenteLeitura) {
      return <span>{rowData.oid}</span>
    }
    return <Link to={`${routes.PATH_CRUD_DINAMICO}/${this.getChave()}/${rowData.oid}`}>{rowData.oid}</Link>
  }

  formatColumn = (rowData, column) => {
    return formatCell(rowData, column)
  }

  fieldFilter = (column) => {
    if (column.tipoCampoCrud === 'boolean') {
      // dropdown Sim/Não: valor booleano vira filtro IGUAL_A no reducer; opção vazia limpa o filtro.
      // LtsDropdownSimNao trabalha com o objeto { label, value } (optionValue identidade + dataKey)
      const valorFiltro = this.valorFiltro(column)
      return (
        <LtsDropdownSimNao
          style={{ width: '100%' }}
          name={column.field}
          value={typeof valorFiltro === 'boolean' ? { label: valorFiltro ? 'Sim' : 'Não', value: valorFiltro } : ''}
          onChange={(opcao) => {
            const valor = opcao && typeof opcao.value === 'boolean' ? opcao.value : ''
            this.props.changeFilter(column, { target: { name: column.field, value: valor } }, this.getChave())
          }}
        />
      )
    }
    if (column.tipoCampoCrud === 'date' || column.tipoCampoCrud === 'datetime') {
      // calendário filtra o dia inteiro (datetime compara ::date no BE); o valor trafega
      // como yyyy-MM-dd com IGUAL_A — o botão Limpar do buttonBar remove o filtro
      const valorFiltro = this.valorFiltro(column)
      return (
        <LtsCalendar
          style={{ width: '100%' }}
          name={column.field}
          value={valorFiltro ? moment(valorFiltro, 'YYYY-MM-DD').toDate() : null}
          dateFormat="dd/mm/yy"
          yearNavigator={true}
          monthNavigator={true}
          yearRange={utils.getYearRangeFromDate('1900')}
          appendTo={document.body}
          showButtonBar={true}
          onChangeEvento={(e) => {
            const valor = e.target.value ? moment(e.target.value).format('YYYY-MM-DD') : ''
            this.props.changeFilter(
              column,
              { target: { name: column.field, value: valor } },
              this.getChave(),
              'IGUAL_A'
            )
          }}
        />
      )
    }
    return (
      <InputText
        style={{ width: '100%' }}
        name={column.field}
        onChange={(e) => this.props.changeFilter(column, e, this.getChave())}
      />
    )
  }

  valorFiltro = (column) => {
    const filtro = (this.props.selectedFilters || []).find((f) => f.campo === column.field)
    return filtro ? filtro.valor : ''
  }

  defineColumns = () => {
    const visibleColumns = this.props.columns.filter((col) => col.visible)
    return visibleColumns.map((col) => {
      col.showFilterMenuOptions = false
      col.showClearButton = false
      col.showFilterMenu = false

      if (col.field === 'multiselect') {
        return <Column selectionMode="multiple" key={col.field} style={{ width: '3em' }} />
      }
      if (col.field === 'oid') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.oidTemplate}
            sortField={col.columnSortField}
            filterElement={col.filter ? this.fieldFilter(col) : null}
          />
        )
      }
      return (
        <Column
          {...col}
          key={col.field}
          body={(rowData) => formatCell(rowData, col)}
          sortField={col.columnSortField}
          filterElement={col.filter ? this.fieldFilter(col) : null}
        />
      )
    })
  }

  buildContent = () => {
    return (
      <CrudDinamicoList
        {...this.props}
        onSelectionChange={this.onSelectionChange}
        dataTableRef={(el) => (this.dataTableRef = el)}
        onPage={this.onPage}
        onSort={this.onSort}
        columns={this.defineColumns()}
      />
    )
  }

  render() {
    if (this.props.columns && this.props.columns.length > 0) {
      // O LoadingSpinner abaixo so cobre a primeira montagem, quando ainda nao ha colunas.
      // Depois disso paginar/ordenar/filtrar refaz a consulta com a grade ja na tela: o
      // `loading` do Page vela so a grade, sem prender o menu nem a toolbar.
      return <Page header={this.buildHeader()} content={this.buildContent()} loading={this.props.isLoadingRecords} />
    }
    return <LoadingSpinner />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CrudDinamicoListPageContainer)
